export const Loading = "Loading/product-loading";
export const Success = "Success/product-Success";
export const Error = "Error/product-Error";

export const Filter_Products = "Filter_Products/product-Filter_Products";

export const SET_FILTERS = "SET_FILTERS/product-SET_FILTERS";
export const Filter_byCheckbox="Filter_Data/product-Filter_byCheckbox";